import localize from '../../../../common/localize';
import ReportSectionTitle from '../../../../components/common/ReportSectionTitle';
import { getValueInCurrency } from '../../../../common/utils';
import {
  getAdditionalCostStatusName,
  getCurrencyFromSetup,
} from '../../../../common/EntitiesManagement';
import TableComponentForReport from './TableComponentForReports';
import ValueOrNoDataLabel from '../../../../components/common/ValueOrNoDataLabel';

export default function ReportAdditionalCosts({ additionalCostData }) {
  return (
    <div>
      <ReportSectionTitle title={localize.additional_costs} />
      <div className="report_section_without_top_border">
        {additionalCostData?.length > 0 ? (
          <TableComponentForReport
            headers={[
              localize.type,
              localize.value,
              localize.status,
              localize.reported_by,
              localize.creation_date,
              localize.observations,
            ]}
            rows={additionalCostData.map((row) => [
              <ValueOrNoDataLabel
                data={row.AdditionalCostType?.Name}
                hideBackground
                centerValue
              />,
              <p className="textAlignedCenter">
                {getValueInCurrency(getCurrencyFromSetup(), row.Value)}
              </p>,
              <p className="textAlignedCenter">
                {getAdditionalCostStatusName(row.Status)}
              </p>,
              <ValueOrNoDataLabel
                data={row.CreatedBy}
                hideBackground
                centerValue
              />,
              <p className="textAlignedCenter">
                {new Date(row.CreationDate).toLocaleString(undefined, {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit',
                  second: '2-digit',
                })}
              </p>,
              <ValueOrNoDataLabel
                data={row.Observation}
                hideBackground
                centerValue
              />,
            ])}
          />
        ) : (
          <label className="report_little_text">{localize.no_data}</label>
        )}
      </div>
    </div>
  );
}
